import React, { useEffect, useState } from "react";
import FeatureUnavailablePopup from "../../ui/FeatureUnavailablePopup/FeatureUnavailablePopup";
import criticalincidentreportsicon from "../../../assets/images/criticalincidentreportsicon.svg";
import resourceicon from "../../../assets/images/resourceicon.svg";
import filesforreviewicon from "../../../assets/images/filesforreviewicon.svg";
import emergencytrackingicon from "../../../assets/images/emergencytrackingicon.svg";
import { useNavigate } from "react-router-dom";
import { GetCountOfCIRAsync } from "../../../services/participantServices/ParticipantService";
import { useAuth } from "../../../firebase/AuthProvider";
import { GetCountOfCIR } from "../../../interfaces/Participant";
import { TriangleAlert } from "lucide-react";
import "./ActionItemsGrid.css";
const ActionItemsGrid: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [count, setCount] = useState<GetCountOfCIR>();
  const [authToken, setAuthToken] = useState<string>("");

  useEffect(() => {
    currentUser?.getIdToken().then((token) => {
      if (token) {
        setAuthToken(token);
        getCountOfCIR(currentUser.uid, token);
      }
    });
  }, []);

  const getCountOfCIR = (userId: string, token: string) => {
    GetCountOfCIRAsync(token, userId).then((res) => {
      if (res.success) {
        setCount(res.data);
      }
    });
  };
  return (
    // <FeatureUnavailablePopup message='Feature is currently unavailable' className='cursor-pointer'>
    <div className="files_grid grid-cols-1 !important">
      <div
        className="files-container"
        //   onClick={() => navigate("/cir")}
      >
        <div className="files-data">
          <div className="files-coming-soon">Coming Soon</div>
          <div className="files-text">
            Critical Incident Reports
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.169236 0.163187C0.222746 0.111459 0.286314 0.0704184 0.356298 0.042416C0.426282 0.0144135 0.501308 0 0.577078 0C0.652848 0 0.727874 0.0144135 0.797858 0.042416C0.867843 0.0704184 0.931411 0.111459 0.984921 0.163187L6 5.00015L0.984921 9.8371C0.876754 9.94141 0.730049 10 0.577078 10C0.424108 10 0.277402 9.94141 0.169236 9.8371C0.0610691 9.7328 0.000302153 9.59134 0.00030215 9.44384C0.000302147 9.29633 0.0610691 9.15487 0.169236 9.05057L4.37093 5.00015L0.169236 0.949721C0.11559 0.898123 0.0730289 0.836827 0.0439886 0.769344C0.0149483 0.701861 0 0.629517 0 0.556454C0 0.483392 0.0149483 0.411047 0.0439886 0.343564C0.0730289 0.276081 0.11559 0.214785 0.169236 0.163187Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div className="files-icons bg-[#FFF6F6]">
          <TriangleAlert color="red" />
        </div>
      </div>
      <div
        className="files-container"
        //   onClick={() => navigate("/cir")}
      >
        <div className="files-data">
          <div className="files-coming-soon">Coming Soon</div>
          <div className="files-text">
            Resource <span>Request</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.169236 0.163187C0.222746 0.111459 0.286314 0.0704184 0.356298 0.042416C0.426282 0.0144135 0.501308 0 0.577078 0C0.652848 0 0.727874 0.0144135 0.797858 0.042416C0.867843 0.0704184 0.931411 0.111459 0.984921 0.163187L6 5.00015L0.984921 9.8371C0.876754 9.94141 0.730049 10 0.577078 10C0.424108 10 0.277402 9.94141 0.169236 9.8371C0.0610691 9.7328 0.000302153 9.59134 0.00030215 9.44384C0.000302147 9.29633 0.0610691 9.15487 0.169236 9.05057L4.37093 5.00015L0.169236 0.949721C0.11559 0.898123 0.0730289 0.836827 0.0439886 0.769344C0.0149483 0.701861 0 0.629517 0 0.556454C0 0.483392 0.0149483 0.411047 0.0439886 0.343564C0.0730289 0.276081 0.11559 0.214785 0.169236 0.163187Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div className="files-icons bg-[#FFECD9]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M11.2917 12.625V13.9583H13.2917L13.9583 20.625H17.9583L18.625 13.9583H20.625V11.9583C20.6248 11.1711 20.4255 10.3968 20.0456 9.70723C19.6658 9.01771 19.1178 8.43544 18.4525 8.01456C17.7873 7.59367 17.0264 7.34785 16.2407 7.29994C15.4549 7.25204 14.6698 7.40361 13.9583 7.74056M15.9583 7.29167V11.2917M13.2917 3.29167C13.2917 3.99891 13.5726 4.67719 14.0727 5.17728C14.5728 5.67738 15.2511 5.95833 15.9583 5.95833C16.6656 5.95833 17.3439 5.67738 17.844 5.17728C18.344 4.67719 18.625 3.99891 18.625 3.29167C18.625 2.58442 18.344 1.90615 17.844 1.40605C17.3439 0.905952 16.6656 0.625 15.9583 0.625C15.2511 0.625 14.5728 0.905952 14.0727 1.40605C13.5726 1.90615 13.2917 2.58442 13.2917 3.29167ZM0.625 5.95833C0.625 7.37282 1.1869 8.72938 2.1871 9.72957C3.18729 10.7298 4.54385 11.2917 5.95833 11.2917C7.37282 11.2917 8.72938 10.7298 9.72957 9.72957C10.7298 8.72938 11.2917 7.37282 11.2917 5.95833C11.2917 4.54385 10.7298 3.18729 9.72957 2.1871C8.72938 1.1869 7.37282 0.625 5.95833 0.625C4.54385 0.625 3.18729 1.1869 2.1871 2.1871C1.1869 3.18729 0.625 4.54385 0.625 5.95833Z"
              stroke="#EF905D"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        className="files-container cursor-pointer"
        onClick={() => navigate("/signDocument?eventkey=inbox")}
      >
        <div className="files-data">
          <div className="files-count">{count?.countOfFileForReview}</div>
          <div className="files-text">
            Signatures
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.169236 0.163187C0.222746 0.111459 0.286314 0.0704184 0.356298 0.042416C0.426282 0.0144135 0.501308 0 0.577078 0C0.652848 0 0.727874 0.0144135 0.797858 0.042416C0.867843 0.0704184 0.931411 0.111459 0.984921 0.163187L6 5.00015L0.984921 9.8371C0.876754 9.94141 0.730049 10 0.577078 10C0.424108 10 0.277402 9.94141 0.169236 9.8371C0.0610691 9.7328 0.000302153 9.59134 0.00030215 9.44384C0.000302147 9.29633 0.0610691 9.15487 0.169236 9.05057L4.37093 5.00015L0.169236 0.949721C0.11559 0.898123 0.0730289 0.836827 0.0439886 0.769344C0.0149483 0.701861 0 0.629517 0 0.556454C0 0.483392 0.0149483 0.411047 0.0439886 0.343564C0.0730289 0.276081 0.11559 0.214785 0.169236 0.163187Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div className="files-icons bg-[#EFFFEF]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g clip-path="url(#clip0_1720_1825)">
              <path
                d="M16.8639 10.5695L14.6541 8.35976M9.12988 16.0937C9.12988 14.6789 9.69191 13.322 10.6924 12.3215L16.5514 6.46253C17.1616 5.85233 18.1509 5.85233 18.7611 6.46253C19.3713 7.07272 19.3713 8.06206 18.7611 8.67222L12.9021 14.5312C12.4067 15.0266 11.8186 15.4196 11.1714 15.6877C10.5241 15.9558 9.83044 16.0937 9.12988 16.0937Z"
                stroke="#00A63E"
                stroke-width="1.875"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.8438 16.9974V17.6562C14.8438 18.5192 14.1442 19.2188 13.2812 19.2188H2.34375C1.48082 19.2188 0.78125 18.5192 0.78125 17.6562V2.34375C0.78125 1.48082 1.48082 0.78125 2.34375 0.78125H11.0715C11.2767 0.781244 11.4799 0.821658 11.6695 0.900183C11.859 0.978709 12.0313 1.09381 12.1764 1.23891L14.3861 3.44859C14.5748 3.63727 14.712 3.87115 14.7847 4.12793"
                stroke="#00A63E"
                stroke-width="1.875"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.90625 16.0938C3.90625 15.2308 4.60582 14.5312 5.46875 14.5312C6.33168 14.5312 7.03125 15.2308 7.03125 16.0938H9.12992M3.90625 5.46875H8.59375M3.90625 8.59375H8.59375"
                stroke="#00A63E"
                stroke-width="1.875"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1720_1825">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div
        className="files-container cursor-pointer"
        onClick={() => navigate("/external-file-request")}
      >
        <div className="files-data">
          <div className="files-count">{count?.externalFileRequestCount}</div>
          <div className="files-text">
            Files For Review
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.169236 0.163187C0.222746 0.111459 0.286314 0.0704184 0.356298 0.042416C0.426282 0.0144135 0.501308 0 0.577078 0C0.652848 0 0.727874 0.0144135 0.797858 0.042416C0.867843 0.0704184 0.931411 0.111459 0.984921 0.163187L6 5.00015L0.984921 9.8371C0.876754 9.94141 0.730049 10 0.577078 10C0.424108 10 0.277402 9.94141 0.169236 9.8371C0.0610691 9.7328 0.000302153 9.59134 0.00030215 9.44384C0.000302147 9.29633 0.0610691 9.15487 0.169236 9.05057L4.37093 5.00015L0.169236 0.949721C0.11559 0.898123 0.0730289 0.836827 0.0439886 0.769344C0.0149483 0.701861 0 0.629517 0 0.556454C0 0.483392 0.0149483 0.411047 0.0439886 0.343564C0.0730289 0.276081 0.11559 0.214785 0.169236 0.163187Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
        <div className="files-icons bg-[#F9F5FF]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
          >
            <path
              d="M17.9297 0H5.97656C5.09628 0.00105857 4.25236 0.352588 3.62991 0.97748C3.00746 1.60237 2.6573 2.4496 2.65625 3.33333V7.03467C3.08575 6.88261 3.53148 6.78148 3.98438 6.73333V3.332C3.98438 2.22933 4.8782 1.332 5.97656 1.332H11.2891V16.5133L12.6929 17.9227C12.9014 18.1213 13.0568 18.3813 13.1577 18.6653H17.9297C19.7598 18.6653 21.25 17.1693 21.25 15.332V3.33333C21.25 1.496 19.7598 0 17.9297 0ZM19.9219 15.3333C19.9219 16.436 19.028 17.3333 17.9297 17.3333H12.6172V1.33333H17.9297C19.028 1.33333 19.9219 2.23067 19.9219 3.33333V15.3333ZM8.35391 15.4533C8.95156 14.68 9.29688 13.7067 9.29688 12.6667C9.29688 10.0933 7.21172 8 4.64844 8C2.08516 8 0 10.0933 0 12.6667C0 15.24 2.08516 17.3333 4.64844 17.3333C5.68437 17.3333 6.65391 16.9867 7.42422 16.3867L10.8242 19.8C10.9437 19.9333 11.1164 20 11.2891 20C11.4617 20 11.6344 19.9333 11.7539 19.8C12.0195 19.5467 12.0195 19.12 11.7539 18.8667L8.35391 15.4533ZM7.30469 14.6667C6.99541 15.0807 6.59437 15.4167 6.13333 15.6481C5.67228 15.8795 5.1639 16 4.64844 16C3.76784 16 2.9233 15.6488 2.30062 15.0237C1.67794 14.3986 1.32812 13.5507 1.32812 12.6667C1.32812 11.7826 1.67794 10.9348 2.30062 10.3096C2.9233 9.68452 3.76784 9.33333 4.64844 9.33333C5.26506 9.33333 5.8695 9.50572 6.39403 9.83116C6.91856 10.1566 7.34245 10.6223 7.61822 11.176C7.89398 11.7296 8.01071 12.3495 7.95533 12.966C7.89996 13.5826 7.67466 14.1714 7.30469 14.6667Z"
              fill="#7E57C2"
            />
          </svg>
        </div>
      </div>
    </div>
    // </FeatureUnavailablePopup>
  );
};

export default ActionItemsGrid;
